.game,
.state {
  inline-size: 100%;
  max-inline-size: 70rem;
  margin-inline: auto;
}

.state {
  display: grid;
  min-block-size: 24rem;
  place-content: center;
  justify-items: center;
  text-align: center;
}

.state h2,
.state p {
  margin: 0 0 var(--space-4);
}

.gameHeader {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: var(--space-4);
  margin-block-end: var(--space-5);
}

.gameHeader h2,
.eyebrow {
  margin: 0;
}

.gameHeader h2 {
  font-size: clamp(1.8rem, 5vw, 3rem);
  letter-spacing: -0.04em;
}

.eyebrow {
  margin-block-end: var(--space-1);
  color: var(--color-accent-strong);
  font-size: var(--font-size-small);
  font-weight: 800;
  text-transform: uppercase;
}

.timer {
  color: var(--color-text-muted);
  font-size: clamp(1.2rem, 4vw, 1.75rem);
  font-variant-numeric: tabular-nums;
  font-weight: 750;
}

.mistakes {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  margin-block: calc(-1 * var(--space-3)) var(--space-4);
  padding: var(--space-1) var(--space-3);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
  font-weight: 750;
}

.mistakes span:last-child {
  color: var(--color-danger);
  font-variant-numeric: tabular-nums;
}

.workspace {
  display: grid;
  grid-template-columns: minmax(18rem, 36rem) minmax(15rem, 20rem);
  gap: clamp(var(--space-4), 5vw, var(--space-8));
  align-items: start;
  justify-content: center;
}

.boardArea {
  display: grid;
  gap: var(--space-3);
}

.pauseActions {
  display: grid;
  justify-items: center;
  gap: var(--space-3);
}

.pauseActions p,
.completed {
  margin: 0;
  font-weight: 750;
  text-align: center;
}

.completed {
  padding: var(--space-3);
  border: 1px solid var(--color-success);
  border-radius: var(--radius-small);
  color: var(--color-success);
}

.failed {
  margin: 0;
  padding: var(--space-3);
  border: 1px solid var(--color-danger);
  border-radius: var(--radius-small);
  color: var(--color-danger);
  font-weight: 750;
  text-align: center;
}

.controls {
  display: grid;
  gap: var(--space-4);
}

.difficulties {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  border: 0;
}

.difficulties legend {
  margin-block-end: var(--space-2);
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
  font-weight: 750;
}

.controls button,
.state button {
  min-block-size: 2.75rem;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-small);
  color: var(--color-text);
  background: var(--color-surface);
  font-weight: 700;
  cursor: pointer;
  touch-action: manipulation;
}

.controls button:hover:not(:disabled),
.state button:hover:not(:disabled),
.controls button[data-active='true'],
.controls button[aria-pressed='true'],
.state button[data-active='true'] {
  border-color: var(--color-accent);
  background: var(--color-selected-cell);
}

.controls button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.numberPad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-1);
}

.numberPad button {
  min-block-size: 3.25rem;
  color: var(--color-accent-strong);
  font-size: 1.2rem;
}

.actionRow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-1);
}

.primary {
  min-block-size: 2.75rem;
  padding-inline: var(--space-5);
  border: 0;
  border-radius: var(--radius-small);
  color: var(--color-on-accent);
  background: var(--color-accent);
  font-weight: 800;
}

@media (max-width: 49rem) {
  .workspace {
    grid-template-columns: minmax(0, 36rem);
  }

  .controls {
    inline-size: 100%;
  }

  .numberPad {
    grid-template-columns: repeat(9, 1fr);
  }

  .numberPad button {
    min-inline-size: 0;
    min-block-size: 2.75rem;
    padding-inline: 0;
  }
}

@media (max-width: 25rem) {
  .numberPad {
    grid-template-columns: repeat(5, 1fr);
  }
}
